const notInter = () => {
  const elements = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul li']
  const targets = []
  elements.forEach((el) => {
    targets.push(`article.content > ${el}`)
  })
  const articles = document.querySelectorAll(targets)

  articles.forEach((el) => {
    const rawText = el.innerHTML
    const pattern = /[\u2460-\u2468|\u25EF|\u2B1C|\20DD|\20DE|\24EA|\25EF|]/g
    const wrappedText = rawText.replace(pattern, '<span class="notInter">$&</span>')
    el.innerHTML = wrappedText
  })
}

export default notInter